export enum MyApprovalStatusEnum {
    TO_BE_APPROVED,
    APPROVED,
    REJECTED,
    APPROVED_AND_REJECTED
}
